module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('detail') === -1) ? _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "上架总部商品说明",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v("\n          通过选择店铺和选择商品，则会将选择的总部商品上架到店铺\n        ")])])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("选择店铺")])]), _vm._v(" "), _c('el-row', {
    staticClass: "content-bottom-padded",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "店铺姓名"
    },
    model: {
      value: (_vm.distributors.params.name),
      callback: function($$v) {
        _vm.$set(_vm.distributors.params, "name", $$v)
      },
      expression: "distributors.params.name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "店铺手机号"
    },
    model: {
      value: (_vm.distributors.params.mobile),
      callback: function($$v) {
        _vm.$set(_vm.distributors.params, "mobile", $$v)
      },
      expression: "distributors.params.mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.distributors.loading),
      expression: "distributors.loading"
    }],
    ref: "multipleDistributorsTable",
    attrs: {
      "data": _vm.distributors.list,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleDistributorsSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              path: _vm.matchHidePage('detail'),
              query: {
                distributor_id: scope.row.distributor_id,
                distributor_name: scope.row.name,
                parentPath: '/mall/marketing/distributor/rel_items'
              }
            }
          }
        }, [_vm._v("商品管理")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleRelItem('_all', scope.row.distributor_id)
            }
          }
        }, [_vm._v("上架全部商品")])]
      }
    }], null, false, 3958460780)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "店铺名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contact",
      "label": "联系人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "联系方式"
    }
  })], 1), _vm._v(" "), (_vm.distributors.total_count > _vm.distributors.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.distributors.params.page,
      "total": _vm.distributors.total_count,
      "page-size": _vm.distributors.params.pageSize
    },
    on: {
      "current-change": _vm.handleDistributorsCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.distributors.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.distributors.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("选择商品")])]), _vm._v(" "), _c('el-row', {
    staticClass: "content-bottom-padded",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品名称"
    },
    model: {
      value: (_vm.items.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.items.params, "keywords", $$v)
      },
      expression: "items.params.keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsNumberSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.items.loading),
      expression: "items.loading"
    }],
    ref: "multipleItemsTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.items.list,
      "height": "400",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleItemsSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "价格",
      "formatter": _vm.priceformatter,
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "store",
      "label": "库存",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rebate",
      "label": "店铺佣金",
      "formatter": _vm.rebateformatter,
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.approve_status == 'onsale') ? _c('span', [_vm._v("前台可销售")]) : (scope.row.approve_status == 'offline_sale') ? _c('span', [_vm._v("可线下销售")]) : _c('span', [_vm._v("不可销售")])]
      }
    }], null, false, 458347217)
  })], 1), _vm._v(" "), (_vm.items.total_count > _vm.items.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.items.params.page,
      "total": _vm.items.total_count,
      "page-size": _vm.items.params.pageSize
    },
    on: {
      "current-change": _vm.handleItemsCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.items.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.items.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-bottom-padded",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleRelItem()
      }
    }
  }, [_vm._v("上架总部商品")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-115a1f06", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-115a1f06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/marketing/distributorRelItems.vue
// module id = 2474
// module chunks = 0